// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOperationsFileJpgSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 5a3 3 0 0 1 3-3h7.172a2 2 0 0 1 1.414.586l3.828 3.828A2 2 0 0 1 20 7.828V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3zm9 3.5a.5.5 0 0 0 .5.5h3.293a.5.5 0 0 0 .353-.854l-3.292-3.292a.5.5 0 0 0-.854.353zm2.052 5.752h.806c-.03.19-.065.28-.135.381-.145.18-.37.28-.641.28-.28 0-.506-.095-.666-.275-.215-.225-.34-.57-.34-.916 0-.676.415-1.182.976-1.182.38 0 .641.19.811.6l.932-.385c-.356-.726-.892-1.062-1.698-1.062-1.217 0-2.048.817-2.048 2.023 0 1.187.821 2.004 2.013 2.004.811 0 1.427-.381 1.738-1.067.14-.3.19-.606.2-1.162h-1.948zm-5.839.166v-2.61h-.981v2.384c0 .231 0 .29-.006.349l-.01.067c-.03.15-.12.235-.26.235-.165 0-.29-.145-.315-.365L7 15.124c.25.38.566.56.987.56.37 0 .7-.14.936-.395.22-.24.29-.446.29-.871zm1.67 1.166v-1.256h.61c.451 0 .762-.11.972-.351.2-.22.305-.54.305-.916 0-.396-.125-.702-.365-.932-.246-.235-.506-.32-.947-.32H9.901v3.775zm.32-2.043h-.32v-.946h.325c.36 0 .536.16.536.475 0 .326-.165.471-.541.471z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOperationsFileJpgSolid;
